<template>
  <div class="card shadow-sm">
    <div class="card-header py-1 px-2">
      <fa-icon icon="heartbeat" /> lifetime [%]
    </div>
    <div class="card-body" style="position: relative;">
      <div class="chart-placehoder" id="lifetime-chart-placeholder">
        <canvas id="lifetime-chart-area" width="100" height="100"></canvas>
      </div>
      <span class="display-1" style="font-size: 7.5rem; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)">
        {{ Math.min(Math.round(currentLife), 100) || '' }}
      </span>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import { mapGetters } from 'vuex'

export default {
  name: 'lifetime',
  data () {
    return {
      chart: null,
      config: {
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: [0, 100],
              borderWidth: 0
            }
          ]
        },
        options: {
          cutoutPercentage: 75,
          events: []
        }
      }
    }
  },
  computed: {
    ...mapGetters(['levelColors', 'level', 'currentLife', 'colors']),
    currentLifeLevel () {
      return this.level.life
    }
  },
  watch: {
    currentLife () {
      this.setColor(this.levelColors[this.currentLifeLevel])
      this.updateChart()
    }
  },
  methods: {
    setColor (color) {
      this.config.data.datasets[0].backgroundColor = [color, this.colors.light]
    },
    createChart () {
      this.setColor(this.levelColors[0])
      const ctx = document.getElementById('lifetime-chart-area').getContext('2d')
      this.chart = new Chart(ctx, this.config)
    },
    updateChart () {
      const val = Math.round(Math.min(this.currentLife, 100))
      this.chart.data.datasets[0].data = [val, 100 - val]
      this.chart.update()
    }
  },
  mounted () {
    this.createChart()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lifetime.vue